import * as React from 'react';
import { connect } from 'react-redux';
import ForgotPassword from './ForgotPassword';
import './ResetPassword.css'

const ResetPassword = () => (
    <div id="ResetPassword" className="pt-5 pb-5">
        <div className="row text-center ml-auto mr-auto">
            <ForgotPassword />
        </div>
    </div>
);

export default connect()(ResetPassword);
